import axios from "./axios-handler.service";
const BASE_URL = "/api/Home";

export interface Consultor {
  idConsultor: string;
  nome: number;
  cpf: string;
  Endereco: string;
  dataCriacao: string;
  dataRecebimento: string;
  dataProcessamento: string;
  erroProcessamento: string;
}

export interface Usuario {
  idUsuario: string;
  nome: string;
  email: string;
  senha: string;
  ativo: boolean;
  administrador: boolean;
}

export interface FiltrosConsultor {
  txtPesquisa: string;
  offset: number;
  limit: number;
  order?: string;
}

export class HomeService {
  static async ListaConsultor(filtro: FiltrosConsultor): Promise<any> {
    const { txtPesquisa, offset, limit, order } = filtro;
    const response = await axios.get(`${BASE_URL}/ListaConsultor`, {
      params: { txtPesquisa, offset, limit, order },
    });
    return response.data;
  }

  static async Logado(): Promise<Usuario> {
    const response = await axios.get(`${BASE_URL}/Logado`);
    return response.data;
  }

  static async Ambiente(): Promise<string> {
    const response = await axios.get(`${BASE_URL}/Ambiente`);
    return response.data;
  }
}
